import React, { FC } from "react";
import "../../styles/App.dark.scss";

const darkTheme: FC = props => <>{props.children}</>;

export default darkTheme;
